// Stroke Play — ported verbatim from GolfGamesScorecard's calcStroke
// (utils/scoring.ts). Lowest cumulative total wins. Net is applied upstream
// (pass net-adjusted players), exactly as the live app does via netScoreGrid.
// GGS twists (Nosey, Throw Out) are descriptive in the live game definition
// and not computed by calcStroke, so they are not computed here either.
export function calcStroke(players) {
  return (players || [])
    .map((p) => ({ ...p, total: p.scores.reduce((s, v) => s + (v ?? 0), 0) }))
    .sort((a, b) => a.total - b.total)
}
